<script>
  import { goto } from '@sapper/app';
  import { onMount } from 'svelte';

  import { productDataStore } from '../../stores/ProductData.js';
  import { designState } from '../../stores/Designer.js';
  import { konvaStageId } from '../../stores/Preview.js';

  import TemplateOptionCard from '../../components/Design/TemplateOptionCard.svelte';
  import ProductTypeSelectionColour from '../../components/Design/ProductTypeSelectionColour.svelte';

  export let resizeFunction;

  let selectedType = $productDataStore.showing;

  $: isSublimationProduct = $productDataStore[$productDataStore.showing].isSublimationProduct;

  function changeSelectedType(type) {
    const showing = $productDataStore.showing;
    if (!$productDataStore[type] && $productDataStore[type + 'sAvailable']) {
      // Navigate back to product selection page and set a hash to enable to the correct section
      // Can't set the showing value in store as we don't have the product data yet.
      goto('/design/' + $productDataStore[showing].slug + '/choose-uniform-items/#' + type);
      return;
    }
    // Here on changing type we also update the showing value in store to trigger preview update.
    switch (type) {
      case 'top':
        selectedType = 'top';
        $productDataStore.showing = 'top';
        break;
      case 'bottom':
        selectedType = 'bottom';
        $productDataStore.showing = 'bottom';
        break;
      case 'hat':
        selectedType = 'hat';
        $productDataStore.showing = 'hat';
        break;
      case 'socks':
        selectedType = 'socks';
        $productDataStore.showing = 'socks';
        break;
      case 'accessories':
        selectedType = 'accessories';
        $productDataStore.showing = 'accessories';
        break;

      default:
        break;
    }
  }

  function changeTemplate(template) {
    $productDataStore[$productDataStore.showing].selectedSublimationTemplate = template;

    designState.updateProductSublimationTemplate($konvaStageId, $productDataStore[$productDataStore.showing], template);
    // On mobile devices we also want to advance to the next step
    // We lose the side control panel at widths less than 700px
    // TODO: This is a bit of a hack, we should probably have a better way of handling this
    if (window.innerWidth < 700) {
      goto('/design/' + $productDataStore[selectedType].slug + '/choose-colours');
    }
  }

  onMount(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const colourOverride = urlParams.get('colour');
    if (colourOverride) {
      const colourOverrideObject = $productDataStore[selectedType].colours.find((c) => c.pathName === colourOverride);
      if (colourOverrideObject) {
        $productDataStore[selectedType].selectedColour = colourOverrideObject;
      }
    }
    const genderOverride = urlParams.get('gender');
    if (genderOverride) {
      $productDataStore[$productDataStore.showing].gender = genderOverride;
    }
    resizeFunction();
  });
</script>

<div class="heading">
  <h2>{$productDataStore[selectedType].name}</h2>
</div>

<div class="content">
  <ProductTypeSelectionColour {selectedType} clickFn={changeSelectedType} />

  {#if isSublimationProduct}
    <div class="options">
      {#if $productDataStore[selectedType]?.sublimationTemplates?.length}
        {#each $productDataStore[selectedType].sublimationTemplates as template}
          <TemplateOptionCard
            {template}
            productRootSlug={$productDataStore[selectedType].rootSlug}
            selected={template.id === $productDataStore[selectedType].selectedSublimationTemplate.id}
            gender={$productDataStore[$productDataStore.showing].gender}
            side={$productDataStore.side}
            clickFn={changeTemplate}
          />
        {/each}
      {:else}
        <div class="no-templates">
          No Templates Available for this Product.<br /><br />
          Go To Next Step to Add Print
        </div>
      {/if}
    </div>
  {:else}
    <div class="no-templates">
      No Templates Available for this Product.<br /><br />
      Go To Next Step to Add Print
    </div>
  {/if}
</div>

<style>
  .heading {
    text-transform: capitalize;
    text-align: center;
    font-size: 1.4rem;
    padding-top: 0.5rem;
  }
  .content {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 8rem;
    padding: 2rem;
    padding-bottom: 60px;
  }

  .options {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 2rem;
    height: fit-content;
  }

  .no-templates {
    text-align: center;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    min-height: 40rem;
  }

  @media screen and (min-width: 600px) {
    .content {
      grid-template-columns: minmax(0, 80px) minmax(0, 1fr);
      gap: 2rem;
    }
  }
</style>
